<template>
  <div class="dm-footer">
    <router-link to="/" class="logo">
      <img src="@/assets/imgs/common/logo.png" class="logo" alt="" />
    </router-link>

    <div class="collapse-card">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          :title="item.title"
          v-for="item in collapseList"
          :key="item.title"
        >
          <div
            v-for="j in item.contentList"
            class="collapse-item"
            :key="j.name"
          >
            <router-link v-if="!j.path.startsWith('http')" :to="j.path">{{
              j.name
            }}</router-link>
            <a v-else :href="j.path" target="_blank">{{ j.name }}</a>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <!-- 联系我们 -->
    <div class="contact-card">
      <div class="contact-title">联系我们</div>
      <div class="contact-content">
        <div
          v-for="item in $publicData.contactList"
          :key="item.label"
          class="contact-content-item"
        >
          <span class="itemLabel">{{ item.label }}</span>
          <span class="itemValue">{{ item.value }}</span>
        </div>
      </div>
    </div>

    <!-- 版权 -->
    <div class="copyright-card">
      ©2018-2025 安徽多点美好智能科技有限公司 版权所有 皖ICP
      <a href="https://beian.miit.gov.cn" class="copyright" target="_blank"
        >备 18022425号-1</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},

  data() {
    return {
      activeName: null,
      collapseList: [
        {
          title: "关于我们",
          contentList: [
            { path: "/about#profile", name: "业务介绍" },
            { path: "/about#development", name: "发展历程" },
            { path: "/about#life", name: "多美生活" },
          ],
        },
        {
          title: "成长关怀",
          contentList: [
            { path: "/growthCare#focusOnPeople", name: "人才发展" },
            { path: "/growthCare#promotion", name: "晋升机制" },
            { path: "/growthCare#salary", name: "薪酬保障" },
            { path: "/growthCare#benefits", name: "福利体系" },
          ],
        },
        {
          title: "我们的文化",
          contentList: [
            { path: "/companyCulture#dmMission", name: "多美使命" },
            { path: "/companyCulture#dmValues", name: "多美价值观" },
            { path: "/companyCulture#dmCulturalLife", name: "文化生活" },
          ],
        },
        {
          title: "招聘职位",
          contentList: [
            {
              path: "https://www.zhipin.com/gongsi/job/3402ab67194d2e271nB42Ny5GQ~~.html?ka=company-jobs",
              name: "招聘职位",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped src="@/assets/styles/mobile/footer.scss"></style>
